import request from '@/utils/request'

// 微信code登录
export const loginByCodeApi = (code) => request({
  url: '/bd/user/loginByWxCode',
  method: 'get',
  params: { code }
})
// 账号密码登录
export const loginByPsdApi = (data) => request({
  url: '/bd/user/login',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
